import axios from "axios";
import { database, ref, onValue, get } from "../../firebase-config";
import { determinePersonality } from "../../client/utils/personalityUtils";

const RESULTS_API_URL = "https://psikotes-server-upj.vercel.app/results";

// Fetch allowedEmails and users
export const fetchAllowedEmailsAndUsers = (setCombinedData) => {
  const allowedEmailsRef = ref(database, 'allowedEmails');
  const usersRef = ref(database, 'users');

  const handleDataChange = () => {
    const allowedEmailsSubscribe = onValue(allowedEmailsRef, (snapshot) => {
      const allowedEmails = snapshot.exists() ? Object.entries(snapshot.val()).map(([id, data]) => ({
        id,
        ...data
      })) : [];

      const usersSubscribe = onValue(usersRef, (snapshot) => {
        const users = snapshot.exists() ? Object.entries(snapshot.val()).map(([id, data]) => ({
          uid: id,
          ...data
        })) : [];

        const combined = allowedEmails.map(allowedEmailData => {
          const userData = users.find(user => user.email === allowedEmailData.email) || {};
          return {
            id: allowedEmailData.id,
            email: allowedEmailData.email,
            statusLogin: allowedEmailData.status,
            createdAt: allowedEmailData.created_at,
            uid: userData.uid || '',
            updatedAt: userData.updated_at || 'N/A',
            statusTes: userData.status_tes || 'N/A'
          };
        });

        setCombinedData(combined);
      });

      return usersSubscribe;
    });

    return allowedEmailsSubscribe;
  };

  return handleDataChange;
};

// Fetch results
export const fetchResults = (setResultsData) => {
  const usersRef = ref(database, 'users');
  const personalityRef = ref(database, 'personalities');

  const handleDataChange = () => {
    let isActive = true;

    const loadResults = async () => {
      try {
        const [resultsResponse, usersSnapshot, personalitySnapshot] = await Promise.all([
          axios.get(RESULTS_API_URL),
          get(usersRef),
          get(personalityRef),
        ]);

        if (!isActive) {
          return;
        }

        const results = resultsResponse.data && !Array.isArray(resultsResponse.data)
          ? resultsResponse.data
          : {};
        const users = usersSnapshot.exists() ? usersSnapshot.val() : {};
        const personalities = personalitySnapshot.exists() ? personalitySnapshot.val() : {};
        const combinedResults = [];

        for (const [psychTestId, psychTestData] of Object.entries(results)) {
          for (const [uid, userResults] of Object.entries(psychTestData || {})) {
            for (const [resultId, resultData] of Object.entries(userResults || {})) {
              const userData = users[uid] || {};
              const personalityType =
                resultData.personality || determinePersonality(resultData.finalResults);
              const personalityData = personalities[personalityType] || {};

              combinedResults.push({
                ...resultData,
                ...userData,
                personalityDescription: personalityData.description,
                personalityType,
                psychTestId,
                resultId,
                uid,
              });
            }
          }
        }

        setResultsData(combinedResults);
      } catch (error) {
        console.error("Failed to fetch admin results:", error.response?.data || error.message || error);

        if (isActive) {
          setResultsData([]);
        }
      }
    };

    loadResults();

    return () => {
      isActive = false;
    };
  };

  return handleDataChange;
};
